var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.2a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8Zm-.8 2.4a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.877 15.004 10 15.77l-.877-.766C5.991 12.27 4.4 9.85 4.4 7.6 4.4 4.417 6.883 2 10 2c3.117 0 5.6 2.417 5.6 5.6 0 2.249-1.59 4.67-4.723 7.404ZM10 3.6c2.243 0 4 1.71 4 4 0 1.638-1.302 3.653-4 6.045C7.302 11.253 6 9.238 6 7.6c0-2.29 1.757-4 4-4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.046 13.616c-.403-.465-.77-.923-1.098-1.372C3.15 12.79 2 13.665 2 14.8c0 2.005 3.584 3.2 8 3.2s8-1.195 8-3.2c0-1.136-1.15-2.011-2.948-2.557-.329.45-.695.907-1.098 1.372 1.49.336 2.446.812 2.446 1.185 0 .646-2.863 1.6-6.4 1.6-3.537 0-6.4-.954-6.4-1.6 0-.373.956-.85 2.446-1.185Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveLocation);
export default __webpack_public_path__ + "static/media/live-location.e6b31ac2.svg";
export { ForwardRef as ReactComponent };